import _1 from './1.jpeg'
import _2 from './2.jpeg'
import _3 from './3.jpeg'
import _4 from './4.jpeg'
import _5 from './5.jpeg'
import _6 from './6.jpeg'

const Avatars = [_1, _2, _3, _4, _5, _6];

export default Avatars